import { Component } from '@angular/core';

import {
  AdvancedFilterModel,
  IFilterParams,
  JoinAdvancedFilterModel,
  TextAdvancedFilterModel,
} from 'ag-grid-enterprise';

import { InputChoicesComponent } from '@camelot/form-input';
import { TranslatePipe } from '@camelot/translation';
import { TextComponent } from '@camelot/ui';

import { ActiveFilterTag } from '../../../../filters/types';
import { BaseFilterComponent } from '../base-col';
import type { AsyncEnumCol } from './async-enum-col';

@Component({
  host: { 'data-cid': 'async-enum-filter' },
  imports: [InputChoicesComponent, TextComponent, TranslatePipe],
  styleUrls: ['../filter.scss'],
  template: `
    @if (this.input) {
      <div>
        <div class="filter-title">
          <cam-text [isBold]="true" size="sm" color="brand-primary">{{ this.filterTitle() | translate }}</cam-text>
        </div>
        <div class="p-space-sm">
          <cam-input-choices
            [input]="$any(this.input)"
            [standalone]="true"
            (valueChanged)="this.applyInputValue($event)"
          ></cam-input-choices>
        </div>
      </div>
    }
  `,
})
export class AsyncEnumFilterComponent extends BaseFilterComponent<
  JoinAdvancedFilterModel | TextAdvancedFilterModel,
  AsyncEnumCol
> {
  override agInit(params: IFilterParams) {
    super.agInit(params);
  }

  override getTags(model?: AdvancedFilterModel | null): ActiveFilterTag[] {
    if (!model) {
      model = this._model;
    }
    if (!model) {
      return [];
    }
    if (model.filterType === 'text') {
      if (model.filter === undefined) {
        return [];
      }
      return [
        {
          condition: model,
          id: model.colId,
          name: (<any>model).filter?.toString() ?? '',
        },
      ];
    }
    if (model.filterType === 'join') {
      return model.conditions.flatMap(condition => this.getTags(condition));
    }

    return [];
  }
}
